import {observer} from 'mobx-react-lite';
import React from 'react';
import FontBody1 from "../../../components/fonts/font-body1/font-body1";
import {FONT_COLOR, FONT_VARIANT} from "../../../components/fonts/font-props";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import CreateRmaDynamicShippingOptionsStore from '../stores/create-rma-dynamic-shipping-store';
import { IColumn } from '../../../components/table/table.types';
import TableRow from '../../../components/table/components/table-row/table-row';
import Table from '../../../components/table/table';
import { RadioButton } from '../../../components/inputs/radio-button/radio-button';
import Currency from "../../../components/currency/currency";
import TextTruncate from "../../../components/text-truncate/text-truncate";

interface IShippingOptionsSectionProps {
    dynamicShippingOptionsStore: CreateRmaDynamicShippingOptionsStore;
    /** distinct per fulfillment, so picking in one group does not clear the native radio in another */
    radioGroupName: string;
    onOptionSelected?: () => void;
}

const ShippingOptionsSection: React.FC<IShippingOptionsSectionProps> = observer(({dynamicShippingOptionsStore, radioGroupName, onOptionSelected}) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-create-rma';

    let tableColumns: IColumn[] = [
        { content: '', width: {value: 40, type: 'px'} },
        { content: getTranslation('SHIPPING_METHOD_TYPE', scope), width: {value: 0.5, type: 'fr'} },
        { content: getTranslation('SHIPPING_SERVICE', scope), width: {value: 1, type: 'fr'} },
        { content: getTranslation('PRICE', scope), width: {value: 0.3, type: 'fr'} },
        { content: '', width: {value: 40, type: 'px'} }
    ];

    return (
        <Table columns={tableColumns}>
            {
                dynamicShippingOptionsStore.shippingOptions.map((option) => {
                    let tableRow = [
                        <RadioButton
                                name={radioGroupName}
                                checked={dynamicShippingOptionsStore.selectedOption?.id === option.id}
                        />
                        , 
                        <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                        {option.name}
                        </FontBody1>
                        ,
                        <TextTruncate>
                            <FontBody1 color={FONT_COLOR.NEUTRAL3}>{option.description}</FontBody1>
                        </TextTruncate>
                        ,
                        <FontBody1 color={FONT_COLOR.PRIMARY3}>
                            <Currency
                                currencyCode={option.currency_code}
                                amount={option.cost}
                                useNative
                            />
                        </FontBody1>
                        ,
                    ];
                    return <TableRow key={option.id} cells={tableRow} onSelect={() => {
                        dynamicShippingOptionsStore.setSelectedOption(option);
                        onOptionSelected?.();
                    }}/>
                })
            }
        </Table>
	);
});

export default ShippingOptionsSection;
